import { useQuery } from '@maui/react-query'
import { useMatiApiClient } from '@/hooks/Intel/client'

const transforms = data => {
  const list = [...data]

  list.sort((a, b) => a.name.localeCompare(b.name))

  const map = {}

  for (const item of list) {
    map[item.id] = item
  }

  return { list, map }
}

const adapters = {
  list: data => data.list,
  map: data => data.map,
}
adapters.default = adapters.list

export const useIndustriesVocabQuery = (options = {}) => {
  const cli = useMatiApiClient()

  return useQuery({
    ...options,
    queryFn: () => cli.industries.fetchVocab().then(transforms),
    queryKey: ['industriesVocab'],
    select: options.select || adapters[options.adapter] || adapters.default,
  })
}
